<template>
  <section class="chart-card" :aria-labelledby="`${idForAria}-heading`">
    <slot />
  </section>
</template>

<script setup>
defineProps({
  idForAria: {
    type: String,
    default: '',
  },
});
</script>

<style lang="less" scoped>
.chart-card {
  position: relative;
  background: @white;
  border-radius: 8px;
  border: 1px solid @stroke-default;
}
</style>
